import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import "../Assets/Css/SchoolList.css";
const Notifications = () => {
  const [isLoading, setLoading] = useState(false);
  // const [teacherData, setTeacherData] = useState([]);
  const [error, setError] = useState(null);
  // Sample teacher data (replace with your API data)
  const teacherData = [
    { id: 1, name: "John Doe", number: "1234567890", school: "School A" },
    { id: 2, name: "Jane Smith", number: "9876543210", school: "School B" },
    { id: 3, name: "Robert Brown", number: "5678901234", school: "School C" },
  ];

  //   const fetchTeacherData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await axios.get("/api/teachers"); // Replace with your endpoint
  //       setTeacherData(response.data);
  //     } catch (err) {
  //       setError("Failed to fetch teacher data. Please try again later.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   useEffect(() => {
  //     fetchTeacherData();
  //   }, []);

  // API Call Handlers
  const handleConfirm = async (id) => {
    try {
      const response = await axios.post(`/api/teachers/${id}/confirm`);
      console.log(`Confirmed Teacher ID: ${id}`, response.data);
      alert("Teacher confirmed successfully.");
      //   fetchTeacherData();
    } catch (error) {
      console.error("Error confirming teacher:", error);
      alert("Failed to confirm teacher. Please try again.");
    }
  };

  // Decline API Call
  const handleDecline = async (id) => {
    try {
      const response = await axios.post(`/api/teachers/${id}/decline`);
      console.log(`Declined Teacher ID: ${id}`, response.data);
      alert("Teacher declined successfully.");
      //   fetchTeacherData();
    } catch (error) {
      console.error("Error declining teacher:", error);
      alert("Failed to decline teacher. Please try again.");
    }
  };

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            <p className="admin_title">Notifications</p>
            {teacherData?.length < 0 || teacherData.length === 0 ? (
              <p className="progressMainTitle text-center ">
                No notifications available.
              </p>
            ) : (
              <div className="card schoolListTableDiv">
                <div
                  className="card-body table-responsive"
                  style={{
                    maxHeight: "700px",
                    //   height: "500px",
                    overflow: "hidden",
                  }}
                >
                  <table className="table ">
                    <thead className="thead-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Teacher Name</th>
                        <th>Teacher Mobile</th>
                        <th>School</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {teacherData.map((teacher) => (
                        <tr key={teacher.id}>
                          <td>{teacher.id}</td>
                          <td>{teacher.name}</td>
                          <td>{teacher.number}</td>
                          <td>{teacher.school}</td>
                          <td>
                            <button
                              className="btn btn-success btn-sm mx-1"
                              onClick={() => handleConfirm(teacher.id)}
                            >
                              Confirm
                            </button>
                            <button
                              className="btn btn-danger btn-sm mx-1"
                              onClick={() => handleDecline(teacher.id)}
                            >
                              Decline
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Notifications;
